<template>
  <div>
    <el-header class="header">
      <nav class="nav">
        <h1 class="logo_wrap">
          <a :href="jumpLink" target="_blank">
            <img src="~/assets/img/header/logo.png" alt="企业社保代缴,电子工资条,薪资代发" title="壹人事" />
          </a>
        </h1>
        <div class="wrap_th">
          <i></i>
          <img src="~/assets/img/header/icon_7th.png" alt="7周年" />
        </div>
        <ul class="navBar">
          <li class="home">
            <a class="transi_all" :href="jumpLink" target="_blank"><span>首页</span></a>
          </li>
          <li class="product">
            <a class="transi_all" :href="jumpLink + '/productsservices'" rel="nofollow" target="_blank">
              <span>产品与服务</span>
              <!-- <img
                style="margin-left:2px;"
                class="transi-all"
                src="~/assets/img/header/down-arrow.svg"
                alt="壹人事-产品"/> -->
            </a>
            <div class="product_down" style="display:none;">
              <div class="product_box">
                <div class="product_list">
                  <p class="product_title">在线HR软件</p>
                  <div class="product_list_box">
                    <a class="product_item nav-pro-roster" target="_blank" :href="jumpLink + '/yuangonghuamingce.html'">
                      <img src="~/assets/img/header/nav_roster.png" alt="员工花名册" />
                      <div class="item_top">
                        <h2 class="item_title">员工花名册</h2>
                        <p class="item_text">
                          云端花名册，自动提醒，自动分析图表
                        </p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-learning" target="_blank"
                      :href="jumpLink + '/employeelearning.html'">
                      <img src="~/assets/img/header/nav_learning.png" alt="员工学习" />
                      <div class="item_top">
                        <h2 class="item_title">员工学习</h2>
                        <p class="item_text">不限培训场景，员工随时学习</p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-salary" target="_blank" :href="jumpLink + '/gongzitiao.html'">
                      <img src="~/assets/img/header/nav_salary.png" alt="电子工资条" />
                      <div class="item_top">
                        <h2 class="item_title">
                          电子工资条
                          <img class="hot_icon" src="~/assets/img/header/icon_hot.png" />
                        </h2>
                        <p class="item_text">
                          多端群发，到达35+国家地区，员工签名确认
                        </p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-attendanc" target="_blank" :href="jumpLink + '/yidongkaoqin.html'">
                      <img src="~/assets/img/header/nav_attendanc.png" alt="移动考勤" />
                      <div class="item_top">
                        <h2 class="item_title">移动考勤</h2>
                        <p class="item_text">
                          多场景考勤需求，一键导出考勤数据
                        </p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-entry" target="_blank" :href="jumpLink + '/zhinengruzhi.html'">
                      <img src="~/assets/img/header/nav_entry.png" alt="智能入职" />
                      <div class="item_top">
                        <h2 class="item_title">智能入职</h2>
                        <p class="item_text">
                          一键发送Offer，小程序极速办理入职
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="product_list">
                  <p class="product_title">员工福利平台</p>
                  <div class="product_list_box">
                    <a class="product_item nav-pro-holiday" target="_blank" :href="jumpLink + '/welfare.html'">
                      <img src="~/assets/img/header/nav_welfare.png" alt="集采员工福利" />
                      <div class="item_top">
                        <h2 class="item_title">集采员工福利</h2>
                        <p class="item_text">
                          14年福利经验，企业在线发放，员工寄送到家
                        </p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-integral" target="_blank" :href="jumpLink + '/jifenfuli.html'">
                      <img src="~/assets/img/header/nav_integral.png" alt="弹性福利" />
                      <div class="item_top">
                        <h2 class="item_title">
                          弹性福利
                          <img class="hot_icon" src="~/assets/img/header/icon_hot.png" />
                        </h2>
                        <p class="item_text">弹性员工福利，多场景，双节税</p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-physicalexam" target="_blank"
                      :href="jumpLink + '/yuangongtijian.html'">
                      <img src="~/assets/img/header/nav_physicalexam.png" alt="员工体检" />
                      <div class="item_top">
                        <h2 class="item_title">员工体检</h2>
                        <p class="item_text">
                          一站式企业员工体检，多区域覆盖，多套餐可选
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="product_list">
                  <p class="product_title">在线人事外包</p>
                  <div class="product_list_box">
                   
                    <a class="product_item nav-pro-deposit" target="_blank" :href="jumpLink + '/depositservice.html'">
                      <img src="~/assets/img/header/nav_deposit.png" alt="社保账户托管" />
                      <div class="item_top">
                        <h2 class="item_title">社保账户托管</h2>
                        <p class="item_text">企业账户托管，在线提交增减员</p>
                      </div>
                    </a>
                    <div class="customer_service">
                      <img src="~/assets/img/img_qywx.png" alt="客服二维码">
                      <div class="service_info">
                        <p class="service_label">客服电话</p>
                        <p class="service_phone">400-189-1900</p>
                        <p class="service_tip">业务咨询，<br/>加企业微信沟通</p>
                      </div>
                    </div> 
                    <!-- <a class="product_item nav-pro-social" target="_blank" :href="jumpLink+'/shebaodaijiao.html'">
                      <img src="~/assets/img/header/nav_social.png?v=20230830" alt="人事管理外包" />
                      <div class="item_top">
                        <h2 class="item_title">人事管理外包
                          <img class="hot_icon" src="~/assets/img/header/icon_hot.png"/>
                        </h2>
                        <p class="item_text">覆盖300+城市，全程在线操作</p>
                      </div>
                    </a>
                    <a class="product_item nav-pro-agent" target="_blank" :href="jumpLink+'/daifagongzi.html'">
                      <img src="~/assets/img/header/nav_pay.png?v=20230830" alt="薪酬管理" />
                      <div class="item_top">
                        <h2 class="item_title">薪酬管理</h2>
                        <p class="item_text">薪酬系统核算个税，45+城市报个税</p>
                      </div>
                    </a> -->
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="welfareMall active">
            <a href="/" rel="nofollow" target="_blank"><span>企业商城</span></a>
            <div class="welfare-down" style="display:none;">
              <div class="welfare-list">
                <div class="welfare-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/icon_welfare1.png" />
                    节日礼包
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank" href="/welfareSetMealList">春节</a>
                    <a class="item-text" target="_blank" href="/welfareSetMealList">端午节</a>
                    <a class="item-text" target="_blank" href="/welfareSetMealList">女神节</a>
                    <a class="item-text" target="_blank" href="/welfareSetMealList">中秋节</a>
                  </div>
                </div>
                <div class="welfare-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/icon_welfare2.png" />
                    企业福利
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank" href="/productList?typeId=1">食品酒饮</a>
                    <a class="item-text" target="_blank" href="/productList?typeId=12">家用电器</a>
                    <a class="item-text" target="_blank" href="/productList?typeId=21">个护清洁</a>
                    <a class="item-text" target="_blank" href="/productList?typeId=0">查看更多>></a>
                  </div>
                </div>
                <div class="welfare-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/icon_welfare3.png" />
                    员工体检
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank" href="/TijianMealList">体检套餐</a>
                    <a class="item-text" target="_blank" href="/organizationList">体检医院</a>
                  </div>
                </div>
                <!-- <div class="welfare-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/icon_welfare4.png" />
                    员工学习
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank" href="/learningIndex">购买视频课程</a>
                  </div>
                </div> -->
              </div>
              <div class="welfare-kefu">
                <div class="kefu-info">
                  <p class="kefu-label">客服电话</p>
                  <p class="kefu-phone">400-189-1900</p>
                </div>
             <img src="~/assets/img/img_qywx.png" alt="客服二维码">
                <p class="kefu-tip">业务咨询，加企业微信沟通</p>
              </div>
            </div>
          </li>
          <li class="info">
            <a class="transi-all" target="_blank" :href="communityLink"><span>壹社区</span></a>
            <div class="info-down" style="display:none;">
              <div class="info-list">
                <div class="info-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/info-icon1.png" />
                    <a :href="jumpLink + '/newslist.html'">政策资讯</a> <br/>
                     <span>每日速递政策资讯与HR干货，助力企业掌握管理动态</span>
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/30.html'">社保新闻</a>
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/25.html'">政策速递</a>
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/53.html'">HRO资讯</a>
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/33.html'">壹人事周刊</a>
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/36.html'">模板下载</a>
                  </div>
                   <div class="item-box">
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/14.html'">社保新闻</a>
                    <a class="item-text" target="_blank" :href="jumpLink + '/newslist/21.html'">政策速递</a>
                    <a class="item-text" target="_blank" style="color: #0089CD;" :href="jumpLink + '/newslist.html'">最新资讯></a>
                  </div>
                </div>
                <div class="info-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/info-icon2.png" />
                    <a  :href="hrLink">HR文库</a> <br/>
                     <span>人事管理资料全收录，海量表格一键获取</span>
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=97a057fe-e97c-45b2-af4c-83e2e7ff75d7'">基础人事</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=dcf8c8aa-de2e-4f00-b941-33270eaf4ff7'">员工关系</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=c14f49b3-ca05-465a-8758-d6a1cc9cdc9f'">培训发展</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=acae0d0c-96b7-48c6-a189-f165ecf148c4'">招聘选拔</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=af78eec7-abbc-4bd6-a366-c764ccd2c2f4'">薪酬福利</a>
                  </div>
                  <div class="item-box">
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=c06c624e-f5fd-4410-9d3f-e08e5cc6746b'">职业修炼</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=4c3d8f99-a55f-4d75-9b01-82256890dbea'">人资规划</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=3852a915-04d4-4149-ac11-51ef1577001e'">绩效管理</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink + '/Home/HRList?TypeID=5ba43730-cf1d-4efd-be8b-80fac6b240fd'">企业文化</a>
                    <a class="item-text" target="_blank"
                      :href="hrLink" style="color: #0089CD;">全部文档></a>
                  </div>
                </div>
                <div class="info-item">
                  <p class="item-title">
                    <img class="item-icon" src="~/assets/img/header/info-icon4.png" />
                   <a  :href="communityLink">HR社区</a>  <br/>
                    <span>问答互动、经验分享、福利活动，HR们的交流圈</span>
                  </p>
                  <div class="item-box">
                    <a class="item-text" target="_blank" :href="communityLink + '/ECommunity/Index?type=2'">热门问题</a>
                    <a class="item-text" target="_blank" :href="communityLink + '/ECommunity/Index?type=3'">最新问题</a>
                    <a class="item-text" target="_blank" :href="communityLink + '/ECommunity/Index?type=4'">待回答</a>
                    <a class="item-text" target="_blank" :href="communityLink + '/ECommunity/Index?type=5'">动态</a>
                  </div>
                   <div class="item-box">
                    <a class="item-text" @click="goUserCenter()">每日打卡</a>
                    <a class="item-text" @click="goUserCenter()">新手任务</a>
                    <a class="item-text" href="javascript:void(0)" @click="goNewActivty()">
                        最新活动 <i class="icon_hot"></i>
                    </a>
                  </div>
                </div>
              </div>
                <div class="info-kefu">
                  <div class="kefu-info">
                      <p class="kefu-label">客服电话</p>
                      <p class="kefu-phone">400-189-1900</p>
                  </div>
                  <img src="~/assets/img/img_qywx.png" alt="客服二维码">
                  <p class="kefu-tip">业务咨询，加企业微信沟通</p>
              </div>
            </div>
          </li>
          <li class="about-person">
            <a class="transi-all" href="javascript:void(0)" rel="nofollow">
              <span>关于壹人事</span>
              <!-- <img class="transi-all" src="~/assets/img/header/down-arrow.svg" alt="壹人事-产品"/> -->
            </a>
            <div class="about-person-down" style="display: none;">
              <div class="about-person-down-content">
                <a class="item" target="_blank" :href="jumpLink + '/aboutus.html'">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person1.png" />
                    <span>壹人事介绍</span>
                  </div>
                  <p class="msg">企业人事管理数字化服务平台，20年经验300+城市 ></p>
                </a>
                <a class="item" target="_blank"
                  href="https://www.echatsoft.com/visitor/pc/chat.html?companyId=12203&echatTag=website">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person2.png" />
                    <span>在线客服</span>
                  </div>
                  <p class="msg">立体客户服务体系，立即接入人工坐席 ></p>
                </a>
                <a class="item" target="_blank" :href="jumpLink + '/solution.html'">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person3.png" />
                    <span>客户案例</span>
                  </div>
                  <p class="msg">2.6万+企业，成功推动客户人事管理提效 ></p>
                </a>
                <a class="item" target="_blank" :href="jumpLink + '/shebaocesuan.html'">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person4.png" />
                    <span>计算工具</span>
                  </div>
                  <p class="msg">
                    五险一金/工资个税/养老金/延迟退休计算，一秒出结果 >
                  </p>
                </a>
                <a class="item" target="_blank" :href="jumpLink + '/helpCenter.html'">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person5.png" />
                    <span>帮助中心</span>
                  </div>
                  <p class="msg">把您的人事问题告诉我们，即刻为您解答 ></p>
                </a>
                <a class="item" target="_blank" :href="jumpLink + '/noviceschool.html'">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person7.png" />
                    <span>新手学堂</span>
                  </div>
                  <p class="msg">1分钟视频，真实系统演示，HR快速上手 ></p>
                </a>
                <a class="item" target="_blank" :href="jumpLink + '/eyzjappdownload.html'">
                  <div class="item-title-box">
                    <img src="~/assets/img/header/about-person8.png" />
                    <span>员工端APP下载</span>
                  </div>
                  <p class="msg">专为企业员工打造的服务app，福利自主兑换 ></p>
                </a>
              </div>
               <div class="about-person-down-right">
                  <h4 class="contact-title">客服电话</h4>
                  <span class="contact-phone">400-189-1900</span>
                  <div class="contact-qrcode">
                      <img src="~/assets/img/img_qywx.png" alt="客服二维码">
                  </div>
                  <p class="contact-desc">业务咨询，加企业微信沟通</p>
              </div>
            </div>
          </li>
        </ul>
        <!-- 全局搜索 -->
        <div class="search">
          <div id="swiperWordBox" class="swiper_wordbox">
            <div id="swiperWordList" class="swiper_wordlist"></div>
          </div>
          <input id="searchIpt" v-model="searchIpt" class="search_ipt" type="text" maxlength="30" placeholder=""
            autocomplete="off" @keyup.enter.native="searchBtn" @input="searchInput()" @focus="searchFocus()" />
          <i class="icon_search" @click="searchBtn"></i>
          <div id="searchResultBox" class="search_result" style="display:none;">
            <ul class="result_box"></ul>
          </div>
          <div id="hotSearchBox" class="hot_search" style="display:none;">
            <ul class="hot_list"></ul>
          </div>
        </div>
        <!-- 登录 -->
        <div class="login-wrap">
          <div class="go-register" v-if="!userData.privateUserID" @click="openLoginDialogCom">
            企业工作台
          </div>
          <div class="login-after login" v-if="userData.privateUserID">
            <a id="workbench" style="margin-top:16px;" class="go-register transi-all radius-20"
              @click="pushWorkbench(userData)" rel="nofollow">企业工作台
            </a>
            <a class="user-img transi-all" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
              <img id="chouti-img" class="img"
                :src="userData.privateUserInfo.privatePhotoUrl ? userData.privateUserInfo.privatePhotoUrl : defaultImg" />
            </a>
            <a id="chouti_name" class="name" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">{{
              userData.privateUserInfo.nickName }}</a>
          </div>
          <div v-else class="nrb-no-login-box">
            <img class="nrb-item-icon" src="~/assets/img/header/user.png" alt="登录/注册" @click="openLoginDialogCom" />
            <span class="nrb-no-login-text header-login-in" @click="openLoginDialogCom">登录 | 注册</span>
            <i class="nrb-no-login-send"></i>
          </div>
          <div class="signing_box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <a target="_blank" :href="jumpLink + '/UserCenter/Index'">用户中心</a>
            <a @click="pushWorkbench(userData)">进入工作台</a>
            <a target="_blank" :href="jumpLink + '/UserCenter/UserTask'">壹豆获取<i class="red_spot"></i></a>
            <a target="_blank" :href="jumpLink + '/UserCenter/UserNotice'">消息<i v-if="isUnread"
                class="red_spot"></i></a>
            <a target="_blank" :href="jumpLink + '/UserCenter/UserAccountSetting'">账号设置</a>
            <a @click="loginOut">退出登录</a>
          </div>
        </div>
      </nav>
    </el-header>
    <Drawer />
    <WebSideWorker />
  </div>
</template>
<script>
import $ from "jquery";
import Drawer from "./userDrawer.vue";
import WebSideWorker from "./websideworker";
import {
  getReqUserInfo,
  getFuzzyQuery,
  getHotSearch,
  GetReadStatus,
} from "network/welfareMall_api.js";
import { mapState } from "vuex";

export default {
  middleware: "layout",
  components: {
    Drawer,
    WebSideWorker,
  },
  data() {
    return {
      userData: {},
      jumpLink: this.preUrlHome,
      jumpLoginLink: this.preUrlOld,
      communityLink: this.communityUrl,
      communityApiLink: this.communityApiUrl,
      hrLink: this.hrUrl,
      defaultImg: require("../assets/img/header/tx.png"), //用户默认头像
      hotsearchIcon: require("../assets/img/header/hot_search.png"), //热门词组icon
      searchTimer: null,
      swiperTimer: null,
      swiperIndex: 0, // 搜索轮播词的当前轮播下标
      searchIpt: "", //搜索框
      isUnread: false,//是否有未读通知
    };
  },
  watch: {
    monitor() {
      if (this.$store.state.useInfo) {
        this.userData = this.$store.state.useInfo;
      }
    },
  },
  computed: {
    // 映射state
    ...mapState(["useInfo", "companyInfo", "cartNum"]),
    monitor() {
      return this.$store.state.useInfo;
    },
  },
  mounted() {
    let _this = this;
    // 产品与服务
    $(".nav .navBar>li.product").mouseenter(function () {
      $(".product_down").show().slideDown("fast");
    });
    $(".nav .navBar > li.product").mouseleave(function () {
      $(".product_down").hide().slideUp("fast");
    });
    //企业商城
    $(".nav .navBar>li.welfareMall").mouseenter(function () {
      $(".welfare-down").show().slideDown("fast");
    });
    $(".nav .navBar>li.welfareMall").mouseleave(function () {
      $(".welfare-down").hide().slideUp("fast");
    });

    //政策与支持
    $(".nav .navBar>li.info").mouseenter(function () {
      $(".info-down").show().slideDown("fast");
    });
    $(".nav .navBar>li.info").mouseleave(function () {
      $(".info-down").hide().slideUp("fast");
    });
    // 关于壹人事
    $(".about-person").mouseenter(function () {
      $(".about-person-down").show().slideDown("fast");
    });
    $(".about-person").mouseleave(function () {
      $(".about-person-down").hide().slideUp("fast");
    });

    // 监听是否点击在输入框以外区域
    document.addEventListener("click", (e) => {
      let searchBoxRow1 = document.getElementById("searchIpt");
      if (!searchBoxRow1.contains(e.target)) {
        $("#searchResultBox").hide();
        $("#hotSearchBox").hide();
        if (!_this.searchIpt) {
          $("#swiperWordBox").show();
        }
      }
    });
    _this.getHotSearchData(); //获取热门搜索词
  },
  created() {
    this.getSearchSwiper(); //搜索框轮播处理
    this.getReadStatus();
  },
  methods: {
    //搜索框轮播处理
    async getSearchSwiper() {
      let _this = this;
      let res = await getHotSearch(1);
      if (res.IsSuccess) {
        let data = res.Data;
        let swiperItemLen = data.length;
        let searchSwiperHtml = "";
        for (let i = 0; i < data.length; i++) {
          searchSwiperHtml += `<div class="swiper_worditem ellipsis swi${i}">${data[i].Name}</div>`;
        }
        if (swiperItemLen) {
          searchSwiperHtml += `<div class="swiper_worditem ellipsis swi${0}">${data[0].Name
            }</div>`;
        }
        document.getElementById("swiperWordList").innerHTML = searchSwiperHtml;
        // 轮播
        let swiperList = document.getElementById("swiperWordList");
        let speed = 1500; // 移动速度
        let boxHeight = 30; // 列表高度
        function marquee() {
          if (!swiperItemLen) return;
          if (swiperList.offsetTop <= -(boxHeight * swiperItemLen)) {
            swiperList.style.transition = "none";
            swiperList.style.top = "0px";
            _this.swiperIndex = 0;
            marquee();
          } else {
            swiperList.style.transition = "all 0.5s ease-in-out";
            swiperList.style.top = swiperList.offsetTop - boxHeight + "px";
            _this.swiperIndex = -(swiperList.offsetTop - boxHeight) / boxHeight;
          }
        }
        _this.swiperTimer = setInterval(marquee, speed);
      }
    },
    //获取热门搜索词
    async getHotSearchData() {
      let res = await getHotSearch(2);
      let reslutData = res.Data;
      let resultListStr = "";
      // console.log(reslutData)
      if (reslutData != "" && reslutData != null) {
        resultListStr += `<div class="hot_header">热门搜索<img src="${this.hotsearchIcon}"></div>`;
        for (let i = 0; i < 5; i++) {
          resultListStr += `<li><a href="${this.jumpLink}/globalsearch.html?search=${reslutData[i].Name}">${reslutData[i].Name}</a></li>`;
        }
        $(".hot_list").html(resultListStr);
      }
    },
    debounce(fn, delay = 100) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(fn, delay);
    },
    // 搜索输入框input事件
    searchInput() {
      this.getSearchValue();
      if (this.searchIpt && this.searchIpt.trim() !== "") {
        this.debounce(this.searchNormal);
      }
    },
    // 搜索输入框focus事件
    searchFocus() {
      this.getSearchValue();
      if (this.searchIpt && this.searchIpt.trim() !== "") {
        this.debounce(this.searchNormal);
      }
    },
    getSearchValue() {
      $("#swiperWordBox").hide();
      if (this.searchIpt && this.searchIpt.trim() !== "") {
        $("#searchResultBox").show();
        $("#hotSearchBox").hide();
      } else {
        $("#searchResultBox").hide();
        $("#hotSearchBox").show();
      }
    },
    searchBtn() {
      let _this = this;
      let iptVal = "";
      let isHiddenRotationphrase = $("#hotSearchBox").is(":hidden");
      let isHiddenNormal = $("#searchResultBox").is(":hidden");
      // 输入框没有点击时,搜索当前轮播词
      if (!_this.searchIpt && isHiddenRotationphrase && isHiddenNormal) {
        iptVal = $(".swi" + _this.swiperIndex).text();
      }
      if (_this.searchIpt) {
        iptVal = _this.searchIpt;
      }
      window.location.href =
        _this.jumpLink + "/globalsearch.html?search=" + iptVal;
    },
    //输入后进行搜索关键字联想
    async searchNormal() {
      let data = await getFuzzyQuery(this.searchIpt);
      let resultListStr = "";
      if (data != "" && data != null) {
        let resNew = data.slice(0, 5);
        for (let i = 0; i < resNew.length; i++) {
          resultListStr += `<li><a href="${this.jumpLoginLink}/globalsearch.html?search=${resNew[i].Title.replace(/<[^>]*>/g, "")}">${resNew[i].Title}</a></li>`;
        }
        $(".result_box").html(resultListStr);
        $("#searchResultBox").show();
        $("#hotSearchBox").hide();
      } else {
        $(".result_box").html("");
        $("#searchResultBox").hide();
        $("#hotSearchBox").show();
      }
    },
    // 登录
    openLoginDialogCom() {
      this.$bus.$emit("openLoginDialogCom");
    },
    // 用户中心
    handleMouseEnter() {
      $(".signing_box").show();
    },
    handleMouseLeave() {
      $(".signing_box").hide();
    },
    goUserCenter() {
      let pctoken = this.GetTokenFromCookie("pcToken");
      if (!pctoken) {
        this.$bus.$emit("openLoginDialogCom");
      } else {
        window.open(`${this.jumpLink}/UserCenter/UserTask`, "_blank");
      }
    },
    goNewActivty(){
       let _this = this;
 $.ajax({
     type: "post",
     url: _this.communityApiLink + "/api/NewestActivityLink/GetNewestActivityLink/GetNewestActivityLink",
     success: (data) => {
         if (data.IsSuccess) {
             window.location.href = data.Message
         }
     },
     error: (err) => {
         console.log(err);
     }
 });
    },
    //点击工作台
    async pushWorkbench() {
      let pctoken = this.GetTokenFromCookie("pcToken");
      if (!pctoken) {
        return;
      }
      let res = await getReqUserInfo();
      if (res.code == 200) {
        let userDataList = res.data;
        if (userDataList.companyList.length == 0) {
          this.$store.commit("openAddCompany");
        } else {
          var userID = userDataList.companyList[0].userID;
          location.href = this.jumpLoginLink + "/Account/Login?token=" + this.GetTokenFromCookie("pcToken") + "&userId=" + userID;
        }
      } else {
        this.$message.warning(res.msg);
        this.loginOut();
      }
    },
    //点击退出
    loginOut() {
      let _this = this;
      $.ajax({
        url: _this.jumpLoginLink + "/Account/LogoutOffice?client=officesite",
        type: "get",
        timeout: 5000,
        dataType: "JSONP", // 处理Ajax跨域问题
        data: { callback: "?" },
        // 默认情况下，标准的跨域请求是不会发送cookie的
        xhrFields: {
          withCredentials: true,
        },
        success: function () {
          $.cookie("pcToken", "", { expires: -1 });
          $.cookie("taskJumpId", "", { expires: -1 });
          _this.delCookie();
          localStorage.removeItem("tokenExpiration");
          localStorage.removeItem("tokenClient");
          console.log($.cookie("pcToken"), 11122);
          window.location.href = _this.preUrlHome;
        },
      });
    },
    // 删除cookie
    delCookie() {
      let cookies = document.cookie.split(";");
      cookies.forEach(function (cookie) {
        let eqPos = cookie.indexOf("=");
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      });
    },
    //获取用户是否有未读通知
    async getReadStatus() {
      let pctoken = this.GetTokenFromCookie("pcToken");
      if (!pctoken) {
        return;
      }
      let res = await GetReadStatus();
      if (res.count) {
        this.isUnread = true;
      }
    }
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.el-header {
  width: 1200px;
  min-height: 70px;
}

.header {
  position: fixed;
  top: 0;
  z-index: 9999;
  background-color: #fff;
  border-bottom: 1px solid #f3f3f3;
  width: 100%;
  height: 70px;

  .transi-all {
    transition: all 0.2s ease-in;
  }

  .nav {
    display: flex;
    width: 1200px;
    height: 100%;
    margin: 0 auto;

    /* LOGO 开始 */
    .logo_wrap {
      width: 108px;
      font-weight: normal;

      .logo {
        margin-right: 10px;
      }

      img {
        max-width: 100%;
        margin-top: 18px;
      }
    }

    /* 周年IMG */
    .wrap_th {
      margin-left: 10px;
      height: 100%;
      display: flex;
      align-items: center;

      i {
        position: relative;
        display: inline-block;
        width: 1px;
        height: 30px;
        background: #eee;
      }

      img {
        margin-top: -8px;
        margin-left: 15px;
        width: 50px;
        height: auto;
        background-size: cover;
      }
    }

    .navBar {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 0 26px 0 40px;

      li {
        line-height: 70px;
        position: relative;
        height: 100%;
        cursor: pointer;
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);

        a {
          font-size: 16px;
          color: #3c3c3c;

          img {
            margin-left: 5px;
          }
        }

        &:hover>a {
          color: #0089cd;

          img {
            transform: rotateX(-180deg);
          }
        }

        &.active a span {
          padding-bottom: 22px;
          color: #0089cd;
          border-bottom: 2px solid #0089cd;
        }
      }

      /* 产品与服务 */
      .product_down {
        position: absolute;
        left: -340px;
        top: auto;
        height: auto;
        background: #fff;
        margin-top: 0;
        cursor: default;
        box-shadow: 0px 3px 6px 1px rgba(152, 152, 152, 0.1);
        border-radius: 0px 0px 20px 20px;
        border: 1px solid #E9E9E9;
        padding: 0 20px;

        .product_box {
          width: 1200px;
          margin: 0 auto;
          padding-top: 35px;
          padding-bottom: 35px;

          .product_list {
            float: left;
            display: inline-block;
            width: 280px;
            margin-left: 50px;

            &:nth-child(1) {
              margin-left: 0;
              width: 540px;

              .product_title {
                width: 540px;
              }
            }

            .product_list_box {
              width: 260px;
              height: 245px;
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
            }

            .product_title {
              width: 260px;
              text-align: left;
              font-size: 18px;
              font-weight: 500;
              color: #3c3c3c;
              line-height: 24px;
              padding-bottom: 20px;
              border-bottom: 1px solid #e8e8e8;
              margin-bottom: 20px;
              margin-left: 10px;
            }

            .product_item {
              display: inline-block;
              width: 260px;
              margin-bottom: 10px;

              &:hover {
                background: #f5f6f7;
                border-radius: 4px;
              }

              img {
                display: inline-block;
                float: left;
                width: 30px;
                height: 30px;
                background-size: 100%;
                margin: 12px 10px 0 10px;
              }

              .item_top {
                padding-top: 12px;
                padding-bottom: 12px;

                .item_title {
                  font-size: 16px;
                  color: #3c3c3c;
                  line-height: 16px;
                  padding-bottom: 4px;

                  .hot_icon {
                    display: inline-block;
                    width: 30px;
                    height: 15px;
                    margin: 0;
                    position: relative;
                    float: none;
                    margin-left: 10px;
                  }
                }

                .item_text {
                  font-size: 12px;
                  color: #9a9a9a;
                  line-height: 16px;
                  padding-left: 50px;
                }
              }
            }
          }
        }

        .customer_service {
          display: flex;
          align-items: center;
          justify-content: space-between;
         background: #569FFF;
          border-radius: 12px;
          padding: 20px 15px 20px 20px;
          margin-top: 20px;
          box-sizing: border-box;
          width: 260px;
          height: 130px;

          img {
            width: 90px;
            height: 90px;
            background: #fff;
            border-radius: 8px;
            padding: 5px;
          }

          .service_info {
            flex: 1;
            text-align: left;
            padding-left: 12px;

            .service_label {
              font-size: 16px;
              color: #FFFFFF;
              margin-bottom: 2px;
              line-height: 16px;
            }

            .service_phone {
                font-size: 18px;
               font-weight: 400;
              color: #fff;
              margin-bottom: 8px;
              line-height: 16px;
            }

            .service_tip {
                  font-size: 12px;
              color: #FFFFFF;
              line-height: 16px;
            }
          }
        }
      }

      /* 企业商城 */
      .welfare-down {
        position: absolute;
        top: 69px;
        left: -400px;
        width: 914px;
        height: auto;
        background: #ffffff;
        box-shadow: 0px 3px 12px 1px rgba(152, 152, 152, 0.15);
        border-radius: 0px 0px 20px 20px;
        border: 1px solid #e9e9e9;
        cursor: default;
        display: flex;
        justify-content: space-between;

        .welfare-list {
          margin: 35px 0 20px;
          display: flex;

          .welfare-item {
            margin-left: 50px;
            display: inline-block;

            &:first-child {
              margin-left: 30px;
            }

            .item-title {
              display: flex;
              padding-bottom: 20px;
              cursor: context-menu;
              font-size: 18px;
              line-height: 20px;
              font-weight: bold;
              color: #3c3c3c;
              width: 170px;
              border-bottom: 1px solid #e8e8e8;

              .item-icon {
                margin-right: 10px;
                display: inline-block;
                width: 20px;
                height: 20px;
                background-size: cover;
                vertical-align: middle;
              }
            }

            .item-box {
              display: inline-flex;
              flex-direction: column;
              margin-top: 22px;
              margin-left: 30px;

              .item-text {
                margin-bottom: 15px;
                display: block;
                font-size: 16px;
                line-height: 16px;
                color: #595959;

                &:hover {
                  cursor: pointer;
                  color: #0089cd;
                }
              }
            }
          }
        }

        .welfare-kefu {
          padding: 30px;
          display: flex;
          flex-direction: column;
          width: 240px;
          height: 306px;
          background: #569FFF;
          border-radius: 0px 0px 20px 0px;

          img {
            width: 140px;
            height: 140px;
            background: #fff;
            border-radius: 8px;
            padding: 5px;
            margin-bottom: 10px;
          }

          .kefu-info {
            margin-bottom: 28px;

            .kefu-label {
                font-size: 16px;
              color: #fff;
              margin-bottom: 8px;
                line-height: 16px;
            }

            .kefu-phone {
              color: #fff;
              font-size: 22px;
                line-height: 16px;
            }
             
          }.kefu-tip {
             font-size: 12px;
             color: #fff;
              line-height: 16px;
            }
        }
      }

      /* 政策与支持 */
      .info-down {
        position: absolute;
        top: 69px;
        left: -400px;
        width: 1000px;
        height: auto;
        background: #ffffff;
        box-shadow: 0px 3px 12px 1px rgba(152, 152, 152, 0.15);
        border-radius: 0px 0px 20px 20px;
        border: 1px solid #e9e9e9;
        cursor: default;
        display: flex;
        .info-list {
          margin: 35px 0 20px;
          display: flex;

          .info-item {
            display: inline-block;
            margin-left: 50px;
             width: 210px;
            &:first-child {
              margin-left: 30px;
            }

            .item-title {
              // display: flex;
              padding-bottom: 15px;
              cursor: context-menu;
              font-size: 18px;
              line-height: 20px;
              font-weight: bold;
              color: #3c3c3c;
              width: 210px;
              border-bottom: 1px solid #e8e8e8;
              margin-bottom: -10px;
              span {
                  font-size: 12px;
                  color: #999999;
                  font-weight: 400;
                  line-height: 18px;
                  display: block;
                  margin-top: 5px;
              }
              .item-icon {
                margin-right: 10px;
                display: inline-block;
                width: 20px;
                height: 20px;
                background-size: cover;
                vertical-align: middle;
              }
            }

            .item-box {
              display: inline-flex;
              flex-direction: column;
              margin-top: 22px;
              // margin-left: 30px;

              &:nth-child(n + 3) {
                margin-left: 40px;
              }

              .item-text {
                margin-bottom: 15px;
                display: block;
                font-size: 16px;
                line-height: 16px;
                color: #595959;

                &:hover {
                  cursor: pointer;
                  color: #0089cd;
                }
              }
            }
          }
        }
        .info-kefu {
        background: #569FFF;
        border-radius: 0 0px 12px 0;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: left;
        width: 240px;
        margin-left: 30px;
    img {
    width: 140px;
    height: 140px;
    background: #fff;
    border-radius: 7px;
    margin-bottom: 10px;
}

    .kefu-info {
    margin-bottom: 28px;
    line-height: 16px;
    .kefu-label {
    font-size: 16px;
  color: #fff;
    margin-bottom: 8px;
}
.kefu-phone {
    font-size: 22px;
    font-weight: 400;
    color: #fff;
}
}
.kefu-tip {
    font-size: 12px;
    color: #FFFFFF;
      line-height: 16px;
}
}
      }

      /* 关于壹人事 */
      .about-person-down {
        position: absolute;
        top: 70px;
        left: -287px;
       width: 918px;
       height: auto;
        background: #ffffff;
        box-shadow: 0px 3px 12px 1px rgba(152, 152, 152, 0.15);
        border-radius: 0px 0px 20px 20px;
        border: 1px solid #e9e9e9;
        line-height: normal;
        display: flex;
        .about-person-down-content {
          padding: 16px 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 678px;
          .item {
            margin-bottom: 8px;
            padding: 8px 10px;
            width: 280px;
            height: 70px;
            border-radius: 4px 4px 4px 4px;
            cursor: pointer;

            &:hover {
              background: #f5f6f7;
            }

            .item-title-box {
              img {
                width: 30px;
                height: 30px;
                vertical-align: -6px;
              }

              span {
                margin-left: 5px;
                font-size: 16px;
                color: #3c3c3c;
              }
            }

            .msg {
              margin-top: 8px;
              font-size: 12px;
              color: #9a9a9a;
            }
          }
        }
      }
      .about-person-down-right {
    width: 240px;
    background: #569FFF;
    border-radius: 0px 0px 20px 0px;
    padding:30px;

.contact-title {
    font-size: 16px;
    color: #FFFFFF;
    margin-bottom: 8px;
    font-weight: normal;
}
 .contact-phone {
    font-size: 22px;
    color: #FFFFFF;
    font-weight: 400;
    margin-bottom: 60px;
    display: block;
}
   .contact-qrcode {
        width: 140px;
        height: 140px;
        margin-bottom: 8px;
    }
 .contact-qrcode img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
 .contact-desc {
    font-size: 12px;
    color: #FFFFFF;
    line-height: 1.4;
}}
    }

    /* 全局搜索 */
    .search {
      position: relative;
      width: 190px;
      height: 40px;
      margin: 15px 0 15px;

      /* 热词轮播 */
      .swiper_wordbox {
        position: absolute;
        top: 5px;
        left: 0px;
        width: 158px;
        height: 30px;
        overflow: hidden;

        .swiper_wordlist {
          position: absolute;
          top: 0;
          left: 0;

          /deep/.swiper_worditem {
            padding-left: 15px;
            width: 158px;
            height: 30px;
            line-height: 30px;
            box-sizing: border-box;
            color: #8b8c9a;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      input {
        width: 190px;
        height: 40px;
        background: #ffffff;
        border: 1px solid #e5e5e5;
        border-radius: 20px;
        padding-left: 10px;
        padding-right: 36px;
        box-sizing: border-box;
        position: absolute;
        background-color: transparent;

        &:focus {
          border: 1px solid #0089cd !important;
        }
      }

      i.icon_search {
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 15px;
        width: 18px;
        height: 18px;
        background: url("../assets/img/header/sousuo.png") no-repeat;

        &:hover {
          background: url("../assets/img/header/sousuo_hover.png") no-repeat;
        }
      }
    }

    /* 搜索结果显示 */
    .search_result {
      position: absolute;
      top: 40px;
      height: auto !important;
      background: #fff;
      width: 334px;
      border: 1px solid #e9e9e9;
      border-radius: 3px;

      // @media screen and (max-width: 1980px) {
      //   left: 56% !important;
      // }
      @media screen and (max-width: 1440px) {
        left: 59% !important;
      }

      @media screen and (max-width: 1200px) {
        left: 710px !important;
      }

      /deep/ .result_box {
        padding: 25px;

        li {
          margin-bottom: 20px;
          cursor: pointer;
          display: -webkit-box;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;

          a {
            font-size: 16px;
            color: #3c3c3c;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .hot_search {
      position: absolute;
      top: 40px;
      height: auto !important;
      background: #fff;
      width: 334px;
      border: 1px solid #e9e9e9;
      border-radius: 3px;

      // @media screen and (max-width: 1980px) {
      //   left: 56% !important;
      // }
      @media screen and (max-width: 1440px) {
        left: 59% !important;
      }

      @media screen and (max-width: 1200px) {
        left: 710px !important;
      }

      /deep/.hot_list {
        width: 334px;
        padding: 10px;

        .hot_header {
          margin-top: 5px;
          padding-left: 10px;
          padding-bottom: 15px;
          font-size: 16px;
          font-weight: bold;
          color: #3c3c3c;
          border-bottom: 1px solid #eaeaea;

          img {
            margin-left: 7px;
          }
        }

        li {
          margin: 10px 10px 20px;

          a {
            font-weight: 400;
            line-height: 16px;
            color: #0089cd;
          }

          &:nth-child(2) {
            margin-top: 15px;
          }

          &:last-child {
            margin-bottom: 10px;
          }
        }
      }
    }

    /* 登录注册 账号中心 */
    .login-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      align-content: center;
      width: 245px;
      color: #3c3c3c;
      font-size: 16px;

      a {
        display: inline-block;

        &.name {
          width: 70px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .go-register {
        cursor: pointer;
        margin-left: 15px;
        display: inline-block;
        height: 36px;
        line-height: 18px;
        padding: 8px 13px;
        font-size: 16px;
        font-weight: bold;
        color: #5688ff;
        border: 1px solid #5688ff;
        border-radius: 18px;
      }

      .nrb-no-login-box {
        margin-left: 15px;
        position: relative;

        .nrb-item-icon {
          width: 24px;
          height: 24px;
          cursor: pointer;
          vertical-align: middle;
        }

        .nrb-no-login-text {
          margin-left: 5px;
          font-size: 16px;
          font-weight: 400;
          color: #3c3c3c;
          cursor: pointer;
        }

        .nrb-no-login-send {
          position: absolute;
          right: -47px;
          top: -15px;
          display: inline-block;
          width: 80px;
          height: 18px;
          background: url("../assets/img/header/send210.png") no-repeat;
          background-size: 100%;
        }
      }

      .login-after {
        display: flex;
        height: 70px;
        line-height: 70px;

        .user-img {
          margin-left: 15px;
          display: inline-block;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          cursor: pointer;

          .img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }

      .signing_box {
        position: fixed;
        top: 62px;
        display: none;
        width: 139px;
        height: 245px;
        padding-top: 12px;
        margin-top: -16px;
        margin-left: 195px;
        background: url(../assets/img/header/signing_box.png);
        background-size: 100% 100%;

        a {
          display: block;
          width: 130px;
          height: 37px;
          line-height: 37px;
          text-align: center;
          margin: 0 auto;
          color: #3c3c3c;

          &:hover {
            cursor: pointer;
            background: #f5f5f5;
          }

          .red_spot {
            position: relative;
            top: -10px;
            right: -6px;
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #f25130;
          }
        }
      }
    }
  }
}
</style>
